export default function throwTranslatableError(error, defaultKey) {
	if (error.response && error.response.data && error.response.data.translationKey) {
		throw new Error(error.response.data.translationKey);
	} else if (error.message) {
		throw new Error(error.message);
	} else {
		throw new Error(defaultKey);
	}
}